import { SelectOption } from '@indigo-ag/component-module';
import { MatriculaBiome } from '@indigo-ag/schema';

import i18next from 'core/i18n';

export const biomeTypesOptions: SelectOption<MatriculaBiome>[] = [
  { name: 'Cerrado', value: MatriculaBiome.CERRADO },
  { name: i18next.t('amazon'), value: MatriculaBiome.AMAZON },
  { name: 'Caatinga', value: MatriculaBiome.CAATINGA },
  { name: i18next.t('atlanticForest'), value: MatriculaBiome.ATLANTIC_FOREST },
  { name: 'Pantanal', value: MatriculaBiome.PANTANAL },
  { name: 'Pampa', value: MatriculaBiome.PAMPA }
];
